module.exports = __webpack_public_path__ + "static/media/credit-card.3088ee7d.png";